import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Modal, Tappable } from '@vectord/components';

import {
  areAllScheduledClassesProcessed,
  resetScheduleClassesForm,
  superBatchesSelector,
  trackerModalSelector,
  useGetClassCreationTrackerQuery,
} from 'features/classCreation';
import ClassCreationTrackerTable from '../ClassCreationTrackerTable';
import styles from './ClassCreationTrackerModal.module.scss';

function ClassCreationTrackerModal({ classes }) {
  const { isOpen, trackerId } = useSelector(trackerModalSelector);
  const [processed, setProcessed] = useState(false);
  const { currentData } = useGetClassCreationTrackerQuery(trackerId, {
    // Stop polling when all classes are processed
    pollingInterval: processed ? undefined : 3000,
    skip: !trackerId,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const superBatches = useSelector(superBatchesSelector);

  const handleClose = useCallback(() => {
    navigate(`/classes/view-schedule/${superBatches[0].value}`);
    dispatch(resetScheduleClassesForm());
  }, [dispatch, navigate, superBatches]);

  useEffect(() => {
    if (areAllScheduledClassesProcessed(currentData)) {
      setProcessed(true);
    }
  }, [currentData]);

  useEffect(() => {
    if (trackerId) {
      setProcessed(false);
    }
  }, [trackerId]);

  return (
    <Modal
      className={styles.root}
      isOpen={isOpen}
      onClose={handleClose}
      size="extraLarge"
      canClose={false}
      unMountOnClose
      withoutHeader
    >
      <ClassCreationTrackerTable
        classes={classes}
        classStatuses={currentData}
      />
      {processed ? (
        <div className="row flex-c m-t-xs m-b-xxs">
          <Tappable
            onClick={handleClose}
            className="btn btn-primary btn-small btn-long"
          >
            View Scheduled Classes
          </Tappable>
        </div>
      ) : (
        <div className="text-c warning m-t-xs m-b-xxs">
          Classes are being created right now. Please do not refresh or close
          this tab.
        </div>
      )}
    </Modal>
  );
}

export default ClassCreationTrackerModal;
